import { Injectable } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { fromEvent, merge, of } from "rxjs";
import { delay, map, switchMap } from "rxjs/operators";

@UntilDestroy()
@Injectable()
export class DelayedHoverService {
    constructor() { }

    createMouseEnterDelay(element: HTMLElement, observer: (boolean) => void, hoverDelay = 300) {
        const hide$ = fromEvent(element, 'mouseleave').pipe(map(_ => null));
        const show$ = fromEvent(element, 'mouseenter').pipe(map(_ => _));

        merge(hide$, show$)
            .pipe(
                untilDestroyed(this),
                switchMap(show => {
                    if (!show) {
                        return of(false);
                    }

                    return of(show).pipe(delay(hoverDelay));
                })
            )
            .subscribe(observer);
    }
}
